// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const sid = {
    field: 'id',
    headerName: 'SID',
    flex: 1,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'products',
    },
    minWidth: 100,
};

export const productId = {
    field: 'productId',
    headerName: 'Product ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productId',
        page: 'products',
    },
    minWidth: 100,
};

export const uuid = {
    field: 'guid',
    headerName: 'UUID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'guid',
        page: 'products',
    },
    minWidth: 200,
};

export const releaseDate = {
    field: 'releaseDate',
    headerName: 'Release Date',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'releaseDate',
        page: 'products',
    },
    minWidth: 100,
};


export const title = {
    field: 'productTitle',
    headerName: 'Title',
    tooltipField: 'title',
    flex: 5,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productTitle',
        page: 'products',
    },
    minWidth: 300,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const type = {
    field: 'productClass',
    headerName: 'Type',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productClass',
        page: 'products',
    },
    minWidth: 100,
};

export const runTime = {
    field: 'runTime',
    headerName: 'Run Time',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'runTime',
        page: 'products',
    },
    minWidth: 100,
};

export const rlLoadStatus = {
    field: 'loadStatus',
    headerName: 'RL Load Status',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'loadStatus',
        page: 'products',
    },
    minWidth: 100,
};

export const details = (
    onOpenDetailsDrawer
) => ({
    headerName: 'Details',
    valueGetter: (data) => {
        return 'DETAILS';
    },
    tooltipField: '',
    cellRenderer: ClickableCellRenderer(onOpenDetailsDrawer, 'fa-eye'),
    minWidth: 125,
});